module.exports = __webpack_public_path__ + "audio-7bd0bb05eebf.m4a";